module.exports = __webpack_public_path__ + "img/23.87d06940.png";